import React, { useState, useEffect, useContext } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DevicesList from './DevicesList';
import { remove } from './../lib/services/device';
import { GlobalErrorContext } from '../context';
import { Device, HttpStatuses } from '../types';

export default function(props: {
  update: () => Promise<void>;
  devices: Device[];
}) {
  const { t } = useTranslation();
  const { setGlobalError } = useContext(GlobalErrorContext);
  const [list, setList] = useState<Device[]>([]);

  useEffect(() => {
    setList(props.devices);
  }, [props.devices]);

  return (
    <>
      <Typography component="h1" variant="h5" align="center">
        {t('trusterListDevices')}
      </Typography>
      <DevicesList
        devices={list}
        update={props.update}
        remove={async (deviceId: string) => {
          const response = await remove(deviceId);
          if (response.status !== HttpStatuses.success) {
            setGlobalError(t('errorDeviceRemove'));
            return false;
          }
          return true;
        }}
      />
    </>
  );
}
